import { DialogProps, Overlay, Root } from '@radix-ui/react-dialog';

import styles from './dialog.module.css';

type OwnDialogProps = DialogProps & { withOverlay?: boolean };

export const Dialog = ({ children, withOverlay, ...props }: OwnDialogProps) => {
	return (
		<Root {...props}>
			{withOverlay && <Overlay className={styles.overlayCover} />}
			{children}
		</Root>
	);
};
